import numeral from 'numeral';
export const longFormat = number => numeral(number).format('0,0');
export const longCurrencyFormat = number => numeral(number).format('$0,0');
export const shortFormat = number => numeral(number).format('0[.]0a');
export const shortCurrencyFormat = number => numeral(number).format('$0[.]00a');